// Day resource (päiväresurssi): inventory booked per calendar day, e.g. a cabin or rental skis.
// `type: 'dayresource'` is set by firebase.createDayResource, not by the form. The form edits the price
// in euros (`price`); ResourcesContainer stores it as `pricePerDay` in cents. Invoicing needs `product`
// (and Fennoa needs `sport`). See docs/features/day-resources.md.
export const _dayResourceClass = {
  displayName: { type: 'string', title: 'Nimi' },
  quantity: { type: 'integer', title: 'Määrä (kpl)', minimum: 1, default: 1 },
  price: { type: 'number', title: 'Hinta per päivä (€, sis. ALV)', minimum: 0 },
  vat: { type: 'number', title: 'ALV %', default: 25.5 },
  product: { type: 'string', title: 'Laskutuksen tuotekoodi' },
  accounting: { type: 'string', title: 'Kirjanpidon tili' },
  sport: { type: 'string', title: 'Laji / ryhmä laskulla' },
  // Options come from config/resourcecategories and the venues at runtime (ResourcesContainer).
  category: { type: 'string', title: 'Kategoria', oneOf: [] },
  venueid: { type: 'string', title: 'Paikka', oneOf: [] },
  description: { type: 'string', title: 'Kuvaus' },
  order: { type: 'number', title: 'Järjestys' },
}

export const _dayResourceRequired = ['displayName', 'quantity', 'price', 'vat', 'product', 'sport']

export const _dayResourceUISchema = {
  quantity: { 'ui:help': '1 = yksittäinen kohde (esim. mökki), enemmän = varastossa oleva määrä (esim. sukset).' },
  price: { 'ui:help': 'Yhden kappaleen hinta yhdeltä päivältä. Varauksen hinta = päivät × määrä × hinta.' },
  description: { 'ui:widget': 'textarea' },
}
